import apiFetch from '@wordpress/api-fetch';
import { SendMail } from '../models/send-mail';

export async function sendMail(sendMail: SendMail): Promise<any> {
	const response: any = await apiFetch({
		path: '/bookr/v1/send-mail',
		method: 'POST',
		data: sendMail,
	});

	return response.data;
}
